/* 가이드 본문 이미지 업로드(dedup) — DESIGN §G-5/§2.4.
   이미지 바이트의 sha256(hex)을 key 로 써서 같은 바이트면 같은 객체 → 1회만 저장(멱등).
   s3.js 동결 시그니처(putObject)만 사용 → fake/live 동일 동작. */
import { putObject } from '../../api/s3.js';

const TYPE_EXT = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/gif': 'gif',
  'image/webp': 'webp',
  'image/svg+xml': 'svg',
};
const ALLOWED = new Set(['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg']);

/* sha256 hex — Web Crypto (repo.js 동형). buffer = ArrayBuffer. */
async function sha256Hex(buffer) {
  const digest = await crypto.subtle.digest('SHA-256', buffer);
  return Array.from(new Uint8Array(digest)).map((b) => b.toString(16).padStart(2, '0')).join('');
}

// 확장자는 파일명 우선, 없거나 미허용이면 MIME 에서 파생.
function extFor(file) {
  const dot = file.name && file.name.lastIndexOf('.');
  const named = dot > 0 ? file.name.slice(dot + 1).toLowerCase() : '';
  if (ALLOWED.has(named)) return named;
  return TYPE_EXT[file.type] || 'png';
}

/* uploadGuideImage(getCredentials, file) => { key }.
   동일 바이트 → 동일 key=dedup, 멱등(중복 업로드해도 같은 객체 덮어씀). */
export async function uploadGuideImage(getCredentials, file) {
  const buf = await file.arrayBuffer();
  const hash = await sha256Hex(buf);
  const ext = extFor(file);
  const key = `official/guide/images/${hash}.${ext}`;
  await putObject(getCredentials, key, new Uint8Array(buf), file.type || 'application/octet-stream');
  return { key };
}

export default uploadGuideImage;
